import { motion } from "framer-motion";
import { Eye, Target } from "lucide-react";

const CARDS = [
  {
    icon: Eye,
    tag: "Nostra Vision",
    title: "Il riferimento italiano per l'ingrosso alimentare halal.",
    text: "Unire culture gastronomiche e professionisti del food con serietà, cura e rispetto delle tradizioni, portando l'eccellenza halal in ogni punto vendita.",
    testid: "vision-card",
  },
  {
    icon: Target,
    tag: "Nostra Mission",
    title: "Qualità halal costante e spedizioni puntuali.",
    text: "Selezionare accuratamente ogni produttore per offrire ai nostri clienti alimenti halal genuini, sicuri e conformi ai più alti standard normativi.",
    testid: "mission-card",
  },
];

export default function VisionMission() {
  return (
    <section id="vision" data-testid="vision-section" className="py-24 bg-[#0b2545] text-white relative overflow-hidden">
      <div className="max-w-6xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-12">
        {CARDS.map((card, i) => (
          <motion.div
            key={card.tag}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, delay: i * 0.15, ease: [0.2, 0.7, 0, 1] }}
            data-testid={card.testid}
            className="p-10 rounded-3xl bg-[#06152d]/60 border border-[#d4af37]/30 space-y-6"
          >
            <div className="w-12 h-12 rounded-2xl bg-[#d4af37]/15 flex items-center justify-center text-[#d4af37]">
              <card.icon className="w-6 h-6" />
            </div>
            <span className="text-xs uppercase font-mono-df tracking-widest text-[#d4af37] block">{card.tag}</span>
            <h3 className="font-display text-3xl font-normal text-white">{card.title}</h3>
            <p className="text-sm text-white/80 leading-relaxed">{card.text}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
